export enum ShipmentPriceValueType {
  SHIPPING_PRICE = 'shipping_price',
  DELIVERED_PRICE = 'delivered_price',
}
